import React from 'react';
import {Col, Row, DatePicker, Checkbox} from 'antd';
import InputField from '../../../../input-field';
import FieldBlock from '../../../../field-block';
import i18n from "../../../../../i18n";

export default function FirstStep({ stepFields, setFields, getFieldErrors, organisationFormsList, countryList, isProprietor, edit = false }) {
    return (
        <>
           <Row gutter={[16, 24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="name"
                label={i18n.t('modals.modalCreateNewLegalEntity.fields.name.title')}
                required={true}
                value={stepFields.name}
                setValue={(value) => {setFields({...stepFields, name: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <FieldBlock name="dateRegistration" title={i18n.t('modals.modalCreateNewLegalEntity.fields.dateRegistration.title')} getErrors={getFieldErrors}>
                <DatePicker
                  style={{ width: "100%" }}
                  value={stepFields.dateRegistration}
                  defaultValue={stepFields.dateRegistration}
                  format="DD.MM.YYYY"
                  size="large"
                  name="dateRegistration"
                  onChange={value => setFields({...stepFields, dateRegistration:  value})}
                />
              </FieldBlock>
            </Col>
          </Row>
           <Row gutter={[16, 24]}>
              <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                  <InputField name="inn" label={i18n.t('modals.modalCreateNewLegalEntity.fields.inn.title')} isDisabled={edit} value={stepFields.inn} setValue={value => setFields({...stepFields, inn: value.replace(/[^0-9]/g, ''), archiveByInn: false})} getFieldErrors={getFieldErrors} />
              </Col>
            { isProprietor ? (
                <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                  <InputField name="ogrnip" label={i18n.t('modals.modalCreateNewLegalEntity.fields.ogrnip.title')} isDisabled={edit} value={stepFields.ogrnip} setValue={value => setFields({...stepFields, ogrnip: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                </Col>
            ) : (
                <>
					<Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField name="kpp" label={i18n.t('modals.modalCreateNewLegalEntity.fields.kpp.title')} value={stepFields.kpp} setValue={value => setFields({...stepFields, kpp: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                    </Col>
					<Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField name="ogrn" label={i18n.t('modals.modalCreateNewLegalEntity.fields.ogrn.title')} isDisabled={edit} value={stepFields.ogrn} setValue={value => setFields({...stepFields, ogrn: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
                    </Col>
                </>
            )}
            <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                <InputField name="okpo" label={i18n.t('modals.modalCreateNewLegalEntity.fields.okpo.title')} value={stepFields.okpo} setValue={value => setFields({...stepFields, okpo: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
          {getFieldErrors('archiveByInn') ?
            <Row gutter={[16, 24]}>
              <Col lg={24} md={24} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                <Checkbox
                name="archiveByInn"
                checked={stepFields.archiveByInn}
                onChange={(e) => {
                  setFields({
                    ...stepFields,
                    archiveByInn: e.target.checked,
                  });
                }}
                style={{fontSize: "10pt", paddingTop: "15px"}}
                getFieldErrors={getFieldErrors}
                >
                  {i18n.t('modals.modalCreateNewLegalEntity.fields.archiveByInn.title')}
                </Checkbox>
              </Col>
            </Row> : null}
        </>
    );
}
